import React, { useState } from 'react';
import { MarketingHeadFlow } from '../ReusableComp/NavBarLeft';
import NavigationBar from '../ReusableComp/NavigationBar';
import Select from '../ReusableComp/Select';
import { Col, Container, Row, Stack, Table } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { getMarketingStaff } from '../../Redux/actions/actions';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Loader from '../ReusableComp/Loader';



const MarketingStafList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [zoneList, setZoneList] = useState([]);
    const [studyList, setStudyList] = useState([]);
    const [zoneSelected, setZoneSelected] = useState("");
    const [studySelected, setStudySelected] = useState("");
    const marketingHeadList = useSelector((state) => (state.marketingStaffList));
    const fsiteList = useSelector((state) => (state.fsiteList));
    const fstudyList = useSelector((state) => (state.fstudyList));

    const [filteredData, setFilteredData] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [asc, setAsC] = useState(false);
    const [desc, setDesc] = useState(false);


    let [loading_flag, Setloading_flag] = useState(false);

    // useEffect(() => {
    //     Setloading_flag(true);
    //     dispatch(getMarketingStaff(
    //         {
    //             mh_id: localStorage.getItem("mh_id")
    //         }
    //     ))
    //     setTimeout(() => {
    //         Setloading_flag(false);
    //       }, 1000);

    // }, [dispatch]);    
    useEffect(() => {
        Setloading_flag(true);
        dispatch(getMarketingStaff({
            mh_id: localStorage.getItem("mh_id")
        }));
    }, [dispatch]);

    useEffect(() => {
        if (marketingHeadList) {
            setFilteredData(marketingHeadList);
            setTimeout(() => {
                Setloading_flag(false);
            }, 200)
        }
    }, [marketingHeadList]);

    function disableBackButton() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', function (event) {
            window.history.pushState(null, null, window.location.pathname);
        });
    }
    useEffect(() => {
        disableBackButton();
    }, [])

    const [currentPage, setCurrentPage] = useState(1)


    const [selectedMS, setSelectedMS] = useState({});

    const handleBackClick = () => {
        setCurrentPage(1)
    }
    const handleSubjectData = (data1) => {
        setSelectedMS(data1)
        setCurrentPage(2)
    }

    function handleEditProfile() {
        alert('Clicked')
    }
    function addAdverseEvent() {
        alert('Adverse event Clicked')
    }
    const getRoleCode = (data) => {
    }
    const handleOptionSelectZone = (e) => {
        let val = e.target.value;
        if (val === "Sites") {
            val = "";
        }
        setZoneSelected(val);
        const filteredData = marketingHeadList?.filter(item =>
            item.ms_study_site_pi.some(ms =>
                ms.study_name.includes(studySelected) && ms.site_name.includes(val) &&
                item.marketing_staff_name && item.marketing_staff_name.toLowerCase().includes(searchText.toLowerCase())
            )
        );
        setFilteredData(filteredData);
    }

    const handleOptionSelectStudy = (e) => {
        let val = e.target.value;
        if (val === "All Studies") {
            val = "";
        }
        setStudySelected(val);
        const filteredData = marketingHeadList?.filter(item =>
            item.ms_study_site_pi.some(ms =>
                ms.study_name.includes(val) && ms.site_name.includes(zoneSelected)
            )
        );
        setFilteredData(filteredData);
    }

    const handleClearFilters = () => {
        setZoneSelected("");
        setStudySelected("");
        setSearchText("");
        setFilteredData(marketingHeadList);
        window.location.reload();
    }

    const handleSearchData = (event) => {
        const searchText = event.target.value.toLowerCase();
        setSearchText(searchText);
        const filteredData = marketingHeadList?.filter((item) => {
            // Convert relevant properties to lowercase for case-insensitive search
            return (
                item.marketing_staff_name && item.marketing_staff_name.toLowerCase().includes(searchText.toLowerCase()) &&
                item.ms_study_site_pi.some(ms =>
                    ms.site_name.includes(zoneSelected)
                )
            );
        });
        // Update the table or do whatever you want with the filteredData
        setFilteredData(filteredData)
    }

    const exportToExcel = () => {
        const workbook = XLSX.utils.book_new();
        const sheetData = [];

        // Prepare the header row
        const headerRow = ['Name', 'Gender', 'Phone Number', 'Date of Joining', 'Sites'];
        sheetData.push(headerRow);

        // Prepare the data rows
        const dataRows = filteredData || marketingHeadList;
        dataRows.forEach((item) => {
            const rowData = [
                item.marketing_staff_name,
                item.sex,
                item.phone_number,
                item.date_of_joining,
                item.ms_study_site_pi.map((study) => study.site_name).join(', ')
            ];
            sheetData.push(rowData);
        });

        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Convert the workbook to an Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        // Create a Blob from the buffer
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        // Save the Blob as an Excel file
        saveAs(blob, 'Marketing_Staff_List.xlsx');
    };

    const [studyOption, setStudyOption] = useState()

    const handleOptionChange = (e, key, value) => {
        setStudyOption(value)
    }

    function convertToTitleCase(str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }

    const handleAscending = () => {
        setAsC(true);
        setDesc(false);

        const sortedData = [...filteredData];
        sortedData.sort((a, b) => {
            const nameA = a.marketing_staff_name || '';
            const nameB = b.marketing_staff_name || '';
            return nameA.localeCompare(nameB);
        });


        setFilteredData(sortedData);
    };

    const handleDescending = () => {
        setDesc(true);
        setAsC(false);

        const sortedData = [...filteredData];
        sortedData.sort((a, b) => {
            const nameA = a.marketing_staff_name || '';
            const nameB = b.marketing_staff_name || '';

            return nameB.localeCompare(nameA);
        });


        setFilteredData(sortedData);
    };

    return (
        <div>
            <NavigationBar title={'Marketing Staff'} studyDropdwn={true} rolecode={getRoleCode} handleOptionChange={handleOptionChange} />
            {/* <MarketingHeadFlow /> */}
            <div className='main_body '>
                {currentPage === 1 && <Container fluid className='py-4 '>
                    <Stack direction="horizontal" gap={3} className="px-2 pb-3 add_subject_stack">

                        <div className=" ">
                            {
                                <select
                                    // value={siteSelected}
                                    onChange={handleOptionSelectZone}
                                    className="custom-select"
                                    style={{ width: "auto" }}
                                >
                                    <option value={"Sites"}>All Sites</option>
                                    {fsiteList?.map((option) => (
                                        <option key={option.value} value={option.value} title={option.label}>
                                            {option.label.length > 60
                                                ? `${option.label.substring(0, 60)}...`
                                                : option.label}
                                        </option>
                                    ))}
                                </select>

                            }
                        </div>
                        {/* <div>
                            <Select
                                selectdivstyl={""}
                                name={"classification"}
                                width={"auto"}
                                label={""}
                                options={fstudyList}
                                initialValue={"All Studies"}
                                onChange={handleOptionSelectStudy}
                            />
                        </div> */}

                        <div>
                            <button className="orange_btn" onClick={handleClearFilters}>Clear</button>
                        </div>

                        <div xs={3} className="ms-auto">
                            <button className="orange_btn" onClick={() => navigate('/mhaddstaff')}>Add Staff</button>
                        </div>
                    </Stack>
                    <Container fluid className='pitable_container px-2'>
                        <Row className='searchbar '>
                            <Col className='searchFiled gap-3'>
                                <label htmlFor="" />
                                <input type="search" value={searchText} onChange={handleSearchData} placeholder='Search with name' />
                                <div className=" ">
                                    <button
                                        className="btn btn-success "
                                        onClick={exportToExcel}
                                        style={{ height: "42px" }}
                                    >
                                        Download XLS
                                        <img src="./images/icons/download.svg" alt="#" style={{ marginLeft: "5px" }} />
                                    </button>
                                </div>
                            </Col>
                        </Row>

                        <div>
                            {loading_flag ? (
                                <div className=''>
                                    <img
                                        className="atrium_loader"
                                        src="/images/circle-effect-loading.gif"
                                        alt="Loader"

                                    />
                                </div>
                            ) : (
                                <div className='' style={{ border: "1px solid #E1E5E7 " }} >
                                    <Table bordered size="sm" className='pitable mb-0'>
                                        <thead className='sticky_table_header'>
                                            <tr>
                                                <th>S.No</th>
                                                <th className='sticky-header'>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                        <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0, paddingLeft: "40px" }}>Marketing Staff Name</span>
                                                        <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ float: "right" }}>
                                                            <g id="icon_sort">
                                                                <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc ? "black" : "#E1E5E7"} onClick={handleDescending} className='svg-cursor' />
                                                                <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc ? "black" : "#E1E5E7"} onClick={handleAscending} className='svg-cursor' />
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </th>
                                                <th>Gender
                                                </th>
                                                <th>Phone Number
                                                </th>
                                                <th>Date of Joining
                                                </th>
                                                <th className='site-name-header'>Sites
                                                </th>
                                                <th>Action
                                                </th>
                                            </tr>
                                        </thead>
                                        {filteredData === null ?
                                            <tbody>
                                                {marketingHeadList?.map((i, index) => {

                                                    return (
                                                        <tr key={i.mh_id} className='text_left_table' >
                                                            <td className='text_right_sno'>{index + 1}</td>
                                                            <td>{i.marketing_staff_name ? convertToTitleCase(i.marketing_staff_name) : "-"}</td>
                                                            <td>{i.sex ? i.sex : "-"}</td>
                                                            <td>+91 {i.phone_number ? i.phone_number : "-"}</td>
                                                            <td className='text-center'>{i.date_of_joining ? i.date_of_joining : "-"}</td>
                                                            <td style={{ display: "flex", flexDirection: "column", height: "45px", overflowY: "scroll", textAlign: "center", padding: (i.ms_study_site_pi.length > 0) ? "12px" : "12px" }}>
                                                                {Array.from(new Set(i.ms_study_site_pi.map(j => j.site_name))).map((uniqueSite, index) => (
                                                                    <span style={{ margin: "0px", fontWeight: "600" }}>{uniqueSite ? (index !== (i.ms_study_site_pi.length - 1) ? `${uniqueSite} ` : uniqueSite) : "-"}</span>
                                                                ))}

                                                            </td>
                                                            <td className='viewbtnstyl'>
                                                                <button className="gray_btn px-3" onClick={() => handleSubjectData(i)}>
                                                                    View
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}

                                            </tbody>
                                            :
                                            <>
                                                {filteredData.length > 0 ? (
                                                    <tbody >
                                                        {filteredData?.map((i, index) => {

                                                            return (
                                                                <tr key={i.mh_id} className='text_left_table' >
                                                                    <td className='text_right_sno'>{index + 1}</td>
                                                                    <td>{i.marketing_staff_name}</td>
                                                                    <td>{i.sex}</td>
                                                                    <td>+91 {i.phone_number}</td>
                                                                    <td className='text-center'>{i.date_of_joining}</td>
                                                                    <td style={{
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        height: "auto",
                                                                        overflowY: "hidden",
                                                                        textAlign: "center",
                                                                        padding: (i.ms_study_site_pi.length > 0) ? "12px" : "0px"
                                                                    }}>
                                                                        {i.ms_study_site_pi.map((site, index) => (
                                                                            <span style={{ margin: "0px", fontWeight: "600" }}>{site.site_name}{index !== (i.ms_study_site_pi.length - 1) ? " " : ""}</span>
                                                                        ))}
                                                                    </td>

                                                                    <td className='viewbtnstyl'>
                                                                        <button className="gray_btn px-3" onClick={() => handleSubjectData(i)}>
                                                                            View
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}


                                                    </tbody>
                                                )
                                                    :
                                                    (

                                                        <tbody>
                                                            <tr className='text-center'>
                                                                <td colSpan='10'>No records found</td>
                                                            </tr>
                                                        </tbody>

                                                    )
                                                }
                                            </>
                                        }

                                    </Table>
                                </div>
                            )}
                        </div>




                    </Container>
                </Container>}
                {currentPage === 2 && selectedMS &&
                    <Container fluid className='py-3 '>
                        <Row className='d-flex justify-content-between'>
                            <Col><button className="white_btn white_btn_back" onClick={handleBackClick}>{'< '}Back</button> </Col>
                        </Row>
                        <Container fluid className='py-3 '>
                            <Row className='viewPage'>
                                <div style={{ padding: "24px 32px" }}>
                                    <p style={{ fontWeight: "bold", color: "black", fontSize: "20px" }}>Name: {selectedMS.marketing_staff_name}</p>
                                </div>
                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px", width: "85vw" }}></div>
                                <div style={{ display: "flex", flexDirection: "row", padding: "24px 32px 5px 32px", justifyContent: "start", alignItems: "center" }}>
                                    <p style={{ marginRight: "20px" }}>
                                        +91 {selectedMS.phone_number}
                                        <img style={{ height: "20px", margin: "6px", paddingLeft: "5px" }} src="./images/icons/Phone Telephone by Streamlinehq (1).svg" alt="" />

                                    </p>
                                    <p style={{ marginRight: "20px", fontWeight: "bolder" }}>.</p>
                                    <p style={{ marginRight: "20px" }}>
                                        {selectedMS.email}
                                        <img style={{ height: "20px", margin: "5px", paddingLeft: "5px" }} src="./images/icons/Mail Send Envelope by Streamlinehqmainemail.svg" alt="" />
                                    </p>
                                    <p style={{ marginRight: "20px", fontWeight: "bolder" }}>.</p>
                                    <p style={{ marginRight: "20px" }}>
                                        {selectedMS.date_of_birth}
                                        <img style={{ height: "20px", margin: "5px", paddingLeft: "5px" }} src="./images/icons/Food Cake by Streamlinehq.svg" alt="" />
                                    </p>
                                </div>

                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px", marginBottom: "32px", width: "85vw" }}></div>
                                {selectedMS.ms_study_site_pi?.map((i) => {
                                    return (
                                        <div className='piViewStudy' style={{ width: "85vw" }}>
                                            <h5 style={{ marginLeft: "42px" }}>{i.study_name}</h5>
                                            <div style={{ border: "1px dotted #E1E5E7", }}></div>
                                            <div className='mappingCard' style={{ padding: "12px" }}>
                                                <div style={{ marginLeft: "32px" }}>
                                                    <h6>Site Address:</h6>
                                                </div>
                                                <div className='mappringCard'>
                                                <div className='mappingCardItem'>
                                                    <p>{i.site_name}</p>
                                                    <p className='marketing-site-address' style={{ textAlign: "start", }}>{i.site_address}, {i.city_name}, {i.state_name}</p>
                                                </div>
                                                <div className='mappingCardItem'>
                                                    <p style={{ textAlign: "start" }}>Principal Investigator : {i.pi_name}</p>
                                                    <p>
                                                          Site phone number: {i.site_phone_number}  &nbsp;
                                                          <img className='site-phone-number' src="./images/icons/Telephone.svg" alt="Telephone" />
                                                    </p>
                                                </div>
                                                </div>
                                            </div>

                                        </div>
                                    )
                                })

                                }
                            </Row>

                        </Container>
                    </Container>
                }
            </div>

        </div>
    );
};

export default MarketingStafList;



